export const colorCoreO3 = "#fc5200"; // strava-orange
export const colorCoreAsphalt = "#000000"; // black
export const colorCoreN6 = "#F2F2F0"; // product - sand
export const colorCoreN7 = "#FAFAFA"; // product-light-sand
export const colorCoreWhite = "#ffffff";
export const colorExpandedLemon = "#ffd800";
export const colorExpandedTeal = "#00ccd7";
export const colorExpandedMaroon = "#4d0000";
export const colorExpandedMoss = "#082929";
export const colorExpandedNavy = "#0b1527";
export const colorExpandedSand = "#f2f2ed"; // marketing-sand
export const colorSecondaryB1 = "#00397C"; // dark-blue
export const colorSecondaryT2 = "#129398"; // dark-teal
export const colorSecondaryG1 = "#437C16"; // dark-green
export const colorSecondaryY2 = "#CC9F00";
export const colorSecondaryG5 = "#A9E27C"; // lime
export const colorSecondaryO6 = "#FDB999"; // peach
export const colorSecondaryP5 = "#ED7DD3"; // pink
export const colorSecondaryY5 = "#FFDD66"; // yellow
export const colorSecondaryT5 = "#73D4D8"; // teal
export const colorAchievementsGold = "#EEAF0B"; // first place medal
export const colorAchievementsSilver = "#8B9699"; // second place
export const colorAchievementsBronze = "#C46C3B"; // third place
export const colorExtendedBlueB00 = "#001329";
export const colorExtendedBlueB05 = "#002653";
export const colorExtendedBlueB1 = "#00397C"; // dark-blue
export const colorExtendedBlueB2 = "#004CA6";
export const colorExtendedBlueB3 = "#0060D0";
export const colorExtendedBlueB4 = "#337FD9";
export const colorExtendedBlueB5 = "#669FE2";
export const colorExtendedBlueB6 = "#99BFEC";
export const colorExtendedBlueB7 = "#CCDFF5";
export const colorExtendedTealT00 = "#042425";
export const colorExtendedTealT05 = "#09494B";
export const colorExtendedTealT1 = "#0D6E72";
export const colorExtendedTealT2 = "#129398"; // dark-teal
export const colorExtendedTealT3 = "#17B8BE";
export const colorExtendedTealT4 = "#45C6CB";
export const colorExtendedTealT5 = "#73D4D8"; // teal
export const colorExtendedTealT6 = "#A2E2E5";
export const colorExtendedTealT7 = "#D0F0F2";
export const colorExtendedGreenG00 = "#162907";
export const colorExtendedGreenG05 = "#2C520E";
export const colorExtendedGreenG1 = "#437C16"; // dark-green
export const colorExtendedGreenG2 = "#59A51D";
export const colorExtendedGreenG3 = "#70CF25";
export const colorExtendedGreenG4 = "#8CD850";
export const colorExtendedGreenG5 = "#A9E27C"; // lime
export const colorExtendedGreenG6 = "#C5EBA7";
export const colorExtendedGreenG7 = "#E2F5D3";
export const colorExtendedRedR00 = "#2D0404";
export const colorExtendedRedR05 = "#5B0909";
export const colorExtendedRedR1 = "#890F0F";
export const colorExtendedRedR2 = "#B71414"; // error-red
export const colorExtendedRedR3 = "#DF2626";
export const colorExtendedRedR4 = "#EA4747";
export const colorExtendedRedR45 = "#EC5D5D";
export const colorExtendedRedR5 = "#EF7575";
export const colorExtendedRedR6 = "#F4A3A3";
export const colorExtendedRedR7 = "#F9D1D1";
export const colorExtendedPinkP00 = "#2C0724";
export const colorExtendedPinkP05 = "#590F49";
export const colorExtendedPinkP1 = "#87176D";
export const colorExtendedPinkP2 = "#B41F92";
export const colorExtendedPinkP3 = "#E127B7";
export const colorExtendedPinkP4 = "#E752C5";
export const colorExtendedPinkP5 = "#ED7DD3"; // pink
export const colorExtendedPinkP6 = "#F3A8E2";
export const colorExtendedPinkP7 = "#F9D3F0";
export const colorExtendedYellowY00 = "#322700";
export const colorExtendedYellowY05 = "#654F00";
export const colorExtendedYellowY1 = "#997700";
export const colorExtendedYellowY2 = "#CC9F00";
export const colorExtendedYellowY3 = "#FFC700";
export const colorExtendedYellowY4 = "#FFD233";
export const colorExtendedYellowY5 = "#FFDD66"; // yellow
export const colorExtendedYellowY6 = "#FFE899";
export const colorExtendedYellowY7 = "#FFF3CC";
export const colorExtendedOrangeO00 = "#321000";
export const colorExtendedOrangeO05 = "#642000";
export const colorExtendedOrangeO1 = "#973100";
export const colorExtendedOrangeO2 = "#C94100";
export const colorExtendedOrangeO3 = "#fc5200"; // strava-orange
export const colorExtendedOrangeO4 = "#FC7433";
export const colorExtendedOrangeO5 = "#FD9766";
export const colorExtendedOrangeO6 = "#FDB999"; // peach
export const colorExtendedOrangeO7 = "#FEDCCC";
export const colorExtendedNeutralN00 = "#000";
export const colorExtendedNeutralN05 = "#141413";
export const colorExtendedNeutralN1 = "#21211f";
export const colorExtendedNeutralN2 = "#43423F";
export const colorExtendedNeutralN3 = "#64635E";
export const colorExtendedNeutralN4 = "#918E89";
export const colorExtendedNeutralN45 = "#C2C1BB";
export const colorExtendedNeutralN5 = "#E0E0DE";
export const colorExtendedNeutralN6 = "#F2F2F0"; // sand
export const colorExtendedNeutralN7 = "#FAFAFA"; // light-sand
export const colorExtendedVioletV00 = "#1C022C";
export const colorExtendedVioletV05 = "#390559";
export const colorExtendedVioletV1 = "#560787";
export const colorExtendedVioletV2 = "#730AB4";
export const colorExtendedVioletV3 = "#900DE1";
export const colorExtendedVioletV4 = "#A63DE7";
export const colorExtendedVioletV5 = "#BC6DED";
export const colorExtendedVioletV6 = "#D29EF3";
export const colorExtendedVioletV7 = "#E8CEF9";
export const colorSocialAppleBlack = "#000000"; // Apple-Black
export const colorSocialAppleGrey = "#555555"; // Apple-Grey
export const colorSocialGoogleBlue = "#4285f4"; // Google-Blue
export const colorSocialGoogleRed = "#db4437"; // Google-Red
export const colorSocialGoogleYellow = "#f4b400"; // Google-Yellow
export const colorSocialGoogleGreen = "#0f9d58"; // Google-Green
export const colorSocialFacebookBlue = "#0865fe"; // Facebook-Blue
export const colorSocialAndroidBlack = "#000000"; // Android-Black
export const colorSocialAndroidGreen = "#32de84"; // Android-Green
export const colorSocialInstagramYellow = "#ffcf33"; // Instagram-Yellow
export const colorSocialInstagramOrange = "#ff6d21"; // Instagram-Orange
export const colorSocialInstagramRed = "#ff005e"; // Instagram-Red
export const colorSocialInstagramPink = "#d800b8"; // Instagram-Pink
export const colorSocialInstagramPurple = "#7234f2"; // Instagram-Purple
export const colorSocialTiktokBlack = "#000000"; // Tiktok-Black
export const colorSocialTiktokWhite = "#ffffff"; // Tiktok-White
export const colorSocialTiktokRed = "#fe2c55"; // Tiktok-Red
export const colorSocialTiktokBlue = "#25f4ee"; // Tiktok-Blue
export const colorSocialXBlack = "#000000"; // X-Twitter-Black
